import { userRoleList } from 'src/services/user/constants';
import { restrictedPaths } from './constants';

export const getRolesForPath = (path: string) =>
  restrictedPaths[path] || userRoleList;
